export interface CoreNgEnvironment {
  [key: string]: any; // Environment can continue as much crap as one wishes
  restUrlOverride?: string;
  gqlUrlOverride?: string;
  gqlWsUrlOverride?: string;
}

// eslint-disable-next-line no-shadow
export enum Environment {
  live = '',
  stage = 'stage',
  test = 'test'
}
